<div fxLayout="column" fxFill fxFlex="100">
  <section fxLayout="column" fxFill fxFlex="100" style="padding-top: 15px">
    <section class="custom-label-container">
      <span class="custom-label-value">Available Media</span>
      <div class="custom-label-underline"></div>
    </section>

    <div fxLayout="row" fxLayoutAlign="space-between" class="margin-top-10px">
      <section>
        <search-field
          class="asset-search"
          [loading]="!(assetsLoaded$ | async)"
          [paginationParams]="params"
          [searchLabel]="'Search Media'"
          (apiSearchStringChanged)="onSearch($event)"
          >
        </search-field>

        <div class="asset-search-filter-container">
          @if ((assetsPagination$ | async) && activeProgram) {
            <mat-form-field
              appearance="outline"
              >
              <mat-select
                placeholder="Both Video and Image"
                [value]="params?.filter?.performType"
                (selectionChange)="onTypeFilter($event)"
                >
                @for (opt of performTypeOpts; track opt) {
                  <mat-option
                    [value]="opt.key"
                    >
                    {{ opt.value }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          }

          @if ((assetsPagination$ | async) && activeProgram) {
            <mat-form-field
              appearance="outline"
              >
              <mat-select
                placeholder="Shared With"
                [value]="params?.filter?.visibility"
                (selectionChange)="onFilter($event)"
                >
                @for (opt of visibilityOpts; track opt) {
                  <mat-option
                    [value]="opt.key"
                    >
                    {{ opt.value }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          }
        </div>
      </section>

      <div fxLayoutAlign="center end" class="asset-create-button">
        <button
          mat-raised-button
          type="button"
          color="primary"
          aria-label="Create New Performance Media Button"
          matTooltip="Create New Media"
          (click)="openCreateAssetDialog()"
          >
          Create New Media
        </button>
      </div>
    </div>
  </section>

  <section>
    <avenue-asset-list
      class="avenueAssetList"
      [assetsPagination]="assetsPagination$ | async"
      [initSelectedAsset]="selectedAsset$ | async"
      [profile]="profileData"
      [updatedAssetMap]="updatedAssetMap"
      (pagingEvent)="onPaginating($event)"
      (onSelectedAsset)="onSelectAsset($event)"
      (editAssetEvent)="openUpdateAssetDialog($event)"
      (deleteAssetEvent)="deleteAsset($event)"
    ></avenue-asset-list>
  </section>
</div>
